import { useEffect } from 'react';
import { useCountUp, useCountUpProps } from 'react-countup';
import { usePreviousNonNullish } from '../helpers';

const DEFAULT_COUNT_UP_CONFIG = {
  separator: ',',
  duration: 0.4,
};

const useNumberCountUp = (
  currentValue?: number,
  countUpConfig?: useCountUpProps,
) => {
  // `currentValue` could be undefined when re-fetching with different parameters
  // so keep track of the previous quote to avoid the counter animation drops
  // to 0 and goes up to the new quote again.
  const prevNumberValue = usePreviousNonNullish(currentValue);
  const value = currentValue ?? prevNumberValue ?? 0;
  const { countUp, update } = useCountUp({
    end: value,
    ...DEFAULT_COUNT_UP_CONFIG,
    ...countUpConfig,
  });

  // react-countup@4.x recreates `update` on every render (no useCallback), so omit it from deps.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => update(value), [value]);

  return countUp;
};

export default useNumberCountUp;
